import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import Figure from 'react-bootstrap/Figure';

function NavbarComp() {
  return (
 
    <Navbar bg=""  expand="lg" >
      <Container>
        <Navbar.Brand >
        <Figure>
      <Figure.Image
        width={101}
        height={100}
        alt="171x180"
        src={require('../video/logos.png')}
      />
      
    </Figure>
        </Navbar.Brand>
        <Navbar.Toggle aria-controls="basic-navbar-nav" />
        <Navbar.Collapse id="basic-navbar-nav">
          <Nav className="me-auto">
          <Nav.Link href="/home">Home</Nav.Link>
            <Nav.Link href="/who">Who we are</Nav.Link>
            <Nav.Link href="/gallery">Picture Gallery</Nav.Link>
            <Nav.Link href="/website">Learn More</Nav.Link>
            <Nav.Link href="/contact">Contact us</Nav.Link>
              
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  
  );
}

export default NavbarComp;